import { getUserLanguage } from '@app/utils'

import { LocalizableEntry } from './types'

export const getOriginalData = (dataList?: LocalizableEntry[]): string => {
  if (!dataList || !dataList.length) return ''

  let translatedData = dataList.find((x) => {
    const userLanguage = getUserLanguage()

    return x.language.toLowerCase() == userLanguage.toLowerCase() && x.original
  })

  if (!translatedData) {
    translatedData = dataList.find((x) => x.original)
  }

  if (!translatedData) {
    translatedData = dataList[0]
  }

  return (translatedData && translatedData.text) || ''
}
